





























import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component({
  name: 'Input'
})
export default class Input extends Vue {
  @Prop() readonly label!: string
  @Prop({ default: false }) readonly required!: boolean
  @Prop({ default: 4 }) readonly rows!: string|number
  @Prop({ default: '' }) readonly placeholder!: string
  @Prop({ default: '' }) readonly id!: string | number
  @Prop({ default: '' }) readonly name!: string
  @Prop({ default: '' }) readonly className!: string
	@Prop({ default: '' }) readonly iconClass!: string
	@Prop({ default: '' }) readonly default!: string
	@Prop({ default: '' }) readonly msgError!: string
	@Prop({ default: null }) readonly hasError!: boolean|null

	value = this.default

  input () {
    this.$emit('input', this.value)
    this.$emit('change', this.value)
  }

  @Watch('default', { immediate: true, deep: true })
  changeOptions (newValue: string, oldValue: string) {
    if (newValue !== oldValue) {
      this.value = this.default
      this.input()
    }
  }
}
